"use client";

import Link from "next/link";
import Image from "next/image";
import { landingCopy } from "./copy";

export default function Footer() {
  const footerSections = [
    landingCopy.footer.product,
    landingCopy.footer.resources,
    landingCopy.footer.company,
    landingCopy.footer.legal,
  ];

  const handleSmoothScroll = (e: React.MouseEvent<HTMLAnchorElement>, href: string) => {
    if (href.startsWith("#")) {
      e.preventDefault();
      const element = document.querySelector(href);
      if (element) {
        const headerOffset = 80;
        const elementPosition = element.getBoundingClientRect().top;
        const offsetPosition = elementPosition + window.pageYOffset - headerOffset;

        window.scrollTo({
          top: offsetPosition,
          behavior: "smooth",
        });
      }
    }
  };

  return (
    <footer className="relative border-t border-border/60 bg-muted/40 backdrop-blur-sm">
      <div
        className="pointer-events-none absolute inset-x-0 top-0 h-px bg-gradient-to-r from-transparent via-primary/35 to-transparent"
        aria-hidden
      />
      <div className="container mx-auto px-4 py-12 sm:px-6 lg:px-8 lg:py-16">
        <div className="mb-12 grid grid-cols-2 gap-8 md:grid-cols-2 lg:grid-cols-6 lg:gap-12">
          {/* Logo and description */}
          <div className="col-span-2 lg:col-span-2">
            <Link href="/" className="inline-block mb-4">
              <Image
                src="/images/GrowFinX Logo Horizontal.svg"
                alt="Growfinx Logo"
                width={160}
                height={72}
                unoptimized
                className="h-8 w-auto"
              />
            </Link>
            <p className="text-sm text-muted-foreground mb-4 max-w-xs">
              Intelligent debt recovery platform. Automate multi-channel campaigns,
              streamline workflows, and maximize recovery rates with real-time analytics.
            </p>
          </div>

          {/* Footer links */}
          {footerSections.map((section, index) => (
            <div key={index}>
              <h3 className="font-semibold text-foreground mb-4 text-sm">
                {section.title}
              </h3>
              <ul className="space-y-3">
                {section.links.map((link, linkIndex) => (
                  <li key={linkIndex}>
                    {link.href.startsWith("#") ? (
                      <a
                        href={link.href}
                        onClick={(e) => handleSmoothScroll(e, link.href)}
                        className="text-sm text-muted-foreground hover:text-foreground transition-colors cursor-pointer"
                      >
                        {link.label}
                      </a>
                    ) : (
                      <Link
                        href={link.href}
                        className="text-sm text-muted-foreground hover:text-foreground transition-colors"
                      >
                        {link.label}
                      </Link>
                    )}
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        <div className="border-t border-border/60 pt-8">
          <p className="text-center text-sm text-muted-foreground">{landingCopy.footer.copyright}</p>
        </div>
      </div>
    </footer>
  );
}

